import {
  GET_ALL_REVIEW_BY_PRODUCT_REQUEST,
  GET_ALL_REVIEW_BY_PRODUCT_SUCCESS,
  GET_ALL_REVIEW_BY_PRODUCT_FAILURE,
  CREATE_REVIEW_FAILURE,
  CREATE_REVIEW_REQUEST,
  CREATE_REVIEW_SUCCESS,
  DELETE_REVIEW_SUCCESS,
  DELETE_REVIEW_REQUEST,
  DELETE_REVIEW_FAILURE,
} from "./ActionType";

const initialState = {
  reviews: [],
  loading: false,
  error: "",
};

export const reviewReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case GET_ALL_REVIEW_BY_PRODUCT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_REVIEW_BY_PRODUCT_SUCCESS:
      return { ...state, reviews: action.payload , loading: false, error: ""};

    case GET_ALL_REVIEW_BY_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case CREATE_REVIEW_REQUEST:
      return { ...state, loading: true };

    case CREATE_REVIEW_SUCCESS:
      return { ...state, createdReview: action.payload , loading: false, error: ""};

    case CREATE_REVIEW_FAILURE:
      return { ...state, loading: false, error: action.payload };

      case DELETE_REVIEW_REQUEST:
        return { ...state, loading: true };
  
      case DELETE_REVIEW_SUCCESS:
        return { ...state, deletedReview: action.payload , loading: false, error: ""};
  
      case DELETE_REVIEW_FAILURE:
        return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
